module.exports = __webpack_public_path__ + "img/zapier.303b5775.png";